import React from 'react';
import {
	styled,
	ParentBoundComponent,
	Module
} from 'ps-gui';

import { getPhrase } from '../../data/phrases';
import AuthenticationCodeModel from './authenticationcodemodel';
import {
	CellMainText,
	CellSubText
} from '../portalresultsetmodule';
import { renderDateTimeCell } from '../commoncellrenderers';

const Wrapper = styled.div`
`;

export default class AuthenticationCodeModule extends ParentBoundComponent {
	getModel() {
		return new AuthenticationCodeModel(this.getData());
	}

	setModel(model) {
		this.setData(model.getData());
	}

	componentDidMount() {
		if (!this.getData().get('initialized')) {
			this.setModel(this.getModel().initialize());
		}
	}

	render() {
		const model = this.getModel();
		
		return (
			<Wrapper>
				<Module
					appState={model.getSearch()}
					onDataChange={newData => this.setData(model.setSearchData(newData))}
					customResultProps={customResultProps}
				//leftToolBar={this.renderCandidateListToolbar}
				//onResultIconMouseDown={this.onCandidateIconMouseDown}
				/>
			</Wrapper>
		);
	}
}

const cellRendererMap = Object.freeze({
	'user': (cell, row, colIndex) => {
		return (
			<>
				<CellMainText>{cell}</CellMainText>
				<CellSubText>{row.get('user_display_name')}</CellSubText>
			</>
		);
	},
	'authentication_code': (cell, row, colIndex) => {
		if (!cell) {
			return '';
		}
		if (cell.length > 16) {
			return cell.substring(0, 6) + '...' + cell.substring(cell.length - 6);
		} else {
			return cell;
		}
	},
	'authentication_code_status': (cell, row, colIndex) => {
		let errorMessage = null;
		const status = row.get('status');
		const clazz = status === 'OK' ? 'ok' : status === 'ERROR' ? 'error' : null;
		if (status === 'ERROR') {
			const sendErrorMessage = row.get('send_error_message');
			const errorCode = row.get('error_code');
			if (sendErrorMessage) {
				errorMessage = getPhrase('sendErrorMessage') + ': ' + sendErrorMessage;
			} else if (errorCode) {
				errorMessage = getPhrase('authenticationErrorCode.' + errorCode);
			}
		}
		return (
			<>
				<CellMainText className={clazz}>{cell}</CellMainText>
				{errorMessage && <CellSubText>{errorMessage}</CellSubText>}
			</>
		);
	},
	'from_date': renderDateTimeCell,
	'to_date': renderDateTimeCell,
	'used_when': renderDateTimeCell,
});

const customResultProps = {
	cellRendererMap,
	defaultColumnWidths: {
		'from_date': '120px',
		'to_date': '120px',
		'used_when': '120px',
		'authentication_code': '160px',
		'authentication_code_type': '190px',
	},
	columnFilters: {
		'login_type': {
			type: 'lookup',
			lookup: 'loginType'
		},
		'session_id': {
			type: 'number',
			groupless: true,
			inputSize: 8,
		},
		'from_date': {
			type: 'date'
		},
		'to_date': {
			type: 'date'
		},
		'used_when': {
			type: 'date'
		},
		sent_to: {
			type: 'text'
		},
		authentication_code: {
			type: 'text'
		},
		user: {
			type: 'lookup',
			lookup: 'user'
		},
		authentication_code_status: {
			type: 'lookup',
			lookup: 'authenticationCodeStatus'
		},
		authentication_code_type: {
			type: 'lookup',
			lookup: 'authenticationCodeType'
		}
	}
};

